import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbButtonDirective } from '@/app/shared/components/ui/button.directive';
import { TablerModule } from '@/app/shared/components/ui/icons/tabler/tabler.module';
import { TwilioCallService, TwilioCallState } from '../services/twilio-call.service';
import { Subscription } from 'rxjs';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { AvatarComponent } from '@/app/shared/components/ui/avatar/avatar.component';
import { TooltipDirective } from '@/app/shared/components/ui/tooltip/tooltip/tooltip.directive';

@Component({
  selector: 'app-twilio-call-controls',
  standalone: true,
  imports: [
    CommonModule,
    UbButtonDirective,
    TablerModule,
    CdkDrag,
    AvatarComponent,
    TooltipDirective,
  ],
  templateUrl: './twilio-call-controls.component.html',
  styleUrl: './twilio-call-controls.component.scss'
})
export class TwilioCallControlsComponent implements OnInit, OnDestroy {
  callState: TwilioCallState = { status: 'idle' };
  private callStateSubscription?: Subscription;
  isMinimized = false;

  constructor(
    private twilioCallService: TwilioCallService
  ) {}

  ngOnInit(): void {
    // Subscribe to call state changes
    this.callStateSubscription = this.twilioCallService.callState$.subscribe(
      (state) => {
        this.callState = state;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.callStateSubscription) {
      this.callStateSubscription.unsubscribe();
    }
  }

  /**
   * Toggle mute/unmute
   */
  toggleMute(): void {
    this.twilioCallService.toggleMute();
  }

  /**
   * Hang up the call
   */
  hangup(): void {
    this.twilioCallService.hangup();
  }

  /**
   * Format duration
   */
  formatDuration(seconds?: number): string {
    if (!seconds) return '00:00';
    return this.twilioCallService.formatDuration(seconds);
  }

  /**
   * Get status label
   */
  getStatusLabel(): string {
    switch (this.callState.status) {
      case 'connecting':
        return 'Connecting...';
      case 'ringing':
        return 'Ringing...';
      case 'connected':
        return 'Connected';
      case 'disconnected':
        return 'Call Ended';
      case 'error':
        return 'Call Error';
      default:
        return 'Idle';
    }
  }

  /**
   * Check if call is active
   */
  isCallActive(): boolean {
    return ['connecting', 'ringing', 'connected'].includes(this.callState.status);
  }

  /**
   * Check if call is connected
   */
  isCallConnected(): boolean {
    return this.callState.status === 'connected';
  }

  toggleMinimize(): void {
    this.isMinimized = !this.isMinimized;
  }
}

